import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

//import styles
import './styles/general.scss';

//pages
import MainPage from './pages/MainPage';
import Success from './pages/Success';

//import styles
import './styles/importedLibrariesStyles.scss';

function App() {
	return (
		<div className='App'>
			<Router>
				<Switch>
					<Route exact path='/' render={(props) => <MainPage {...props} />} />
					<Route
						exact
						path='/success'
						render={(props) => <Success {...props} />}
					/>
				</Switch>
				<footer className='footer'>
					<p>© {new Date().getFullYear()} | Sarah Abdelfattah</p>
				</footer>
			</Router>
		</div>
	);
}

export default App;
